import styled from "styled-components";

const Contenedor = styled.div`
    background: #fff; /* Color de fondo del contenedor prinicipal*/
    width: 100%;
    margin: auto;
    height: 100vh;
    overflow-y: auto;
    max-width: 100rem; /* 1600px*/
    height: 100vh; /* 90vh = 90% del alto del viewport*/
    border-radius: 0.625rem; /* 10px */
    display: flex;
    flex-direction: column;
    align-items: center;

    @media(max-width: 150rem){ /* ??px */
        max-width: 140rem;
    }
`;



export {Contenedor};